import { Grid } from "@material-ui/core";
import { SelectIcon } from "App/Assets";
import { InputOptionMaster, MasterButton, Modal } from "App/Component/ui";
import React from "react";
import { useSelector } from "react-redux";
import { validasiLayananPasien } from "./helpers";
import { defaultToastError, isNull } from "App/utils/helpers";

function FormJenisLayanan({ handleChange, formData }) {
  const stateRedux = useSelector((state) => state);
  const master = stateRedux.master;
  const jenisLayanan = master.jenis_layanan.list_select;

  const handleClickValidasiLayanan = async () => {
    if (!isNull(formData.patients_id)) {
      const response = await validasiLayananPasien({
        patients_id: formData.patients_id,
        kode_jenis_kunjungan: "HDL",
      });

      if (response.state) {
        setShowModal(true);
        setText(response.data.text);
      } else {
        defaultToastError("Pasien tidak memiliki jadwal atau request HD");
      }
    } else {
      defaultToastError("Pilih pasien terlebih dahulu");
    }
  };

  const [text, setText] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      {showModal && (
        <Modal title='Validasi Layanan Pasien' show={() => setShowModal(false)}>
          <p>{text}</p>
        </Modal>
      )}

      <Grid item xs={3}>
        <div
          style={{
            display: "flex",
            gap: "0 0.5rem",
          }}>
          <InputOptionMaster
            name='jenis_layanan_id'
            label='JENIS LAYANAN'
            id='jenis_layanan_id'
            withSearch={false}
            data={jenisLayanan}
            value={formData.jenis_layanan_id}
            onChange={handleChange("jenis_layanan_id")}
          />

          <MasterButton
            type={"button"}
            color='lightgreen'
            name=''
            size='sm'
            onClick={() => handleClickValidasiLayanan()}
            withIcon={true}
            style={{
              marginTop: "1.5rem",
              width: "32px",
              height: "32px",
            }}
            icon={
              <SelectIcon
                width='16px'
                height='16px'
                style={{
                  marginLeft: "-0.5rem",
                }}
              />
            }
          />
        </div>
      </Grid>
    </>
  );
}

export default FormJenisLayanan;
